/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSubscriptionPaymentMethodBody
 */
export interface UpdateSubscriptionPaymentMethodBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionPaymentMethodBody
     */
    paymentMethodId: string;
}

/**
 * Check if a given object implements the UpdateSubscriptionPaymentMethodBody interface.
 */
export function instanceOfUpdateSubscriptionPaymentMethodBody(value: object): value is UpdateSubscriptionPaymentMethodBody {
    if (!('paymentMethodId' in value) || value['paymentMethodId'] === undefined) return false;
    return true;
}

export function UpdateSubscriptionPaymentMethodBodyFromJSON(json: any): UpdateSubscriptionPaymentMethodBody {
    return UpdateSubscriptionPaymentMethodBodyFromJSONTyped(json, false);
}

export function UpdateSubscriptionPaymentMethodBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubscriptionPaymentMethodBody {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethodId': json['paymentMethodId'],
    };
}

export function UpdateSubscriptionPaymentMethodBodyToJSON(json: any): UpdateSubscriptionPaymentMethodBody {
    return UpdateSubscriptionPaymentMethodBodyToJSONTyped(json, false);
}

export function UpdateSubscriptionPaymentMethodBodyToJSONTyped(value?: UpdateSubscriptionPaymentMethodBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentMethodId': value['paymentMethodId'],
    };
}

